import React from "react";

import * as Icon from "@phosphor-icons/react"

const Footer = () => {
  return (
    <footer className="relative">
      <div className="bg-greenprimary py-8">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 text-pink">
            <div className="rounded-2xl border border-pink/20 bg-white/50 p-5">
              <h4 className="font-bold">Besoin d&apos;aide rapidement ?</h4>
              <p className="text-sm pt-1 pb-2">
                Notre équipe vous répond vite sur WhatsApp ou via notre page contact.
              </p>
              <div className="flex flex-wrap items-center gap-3 mt-4">
                <a
                  href="https://wa.me/212664045333"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-xl bg-pink text-white px-4 py-3 font-semibold hover:opacity-90 transition-opacity"
                >
                  <Icon.ChatCircleText size={20} weight="bold" />
                  WhatsApp
                </a>
                <a
                  href="/pages/contact"
                  className="inline-flex items-center gap-2 rounded-xl border border-pink px-4 py-3 font-semibold hover:bg-pink/10 transition-colors"
                >
                  <Icon.EnvelopeSimple size={20} weight="bold" />
                  Page Contact
                </a>
              </div>
            </div>

            <div className="rounded-2xl border border-pink/20 bg-white/50 p-5 flex flex-col items-center justify-center text-center">
              <h4 className="font-bold">
                Aidez-nous à nous améliorer
              </h4>
              <p className="text-sm pt-1 pb-2">
                Répondez à un bref sondage sur la visite d&apos;aujourd&apos;hui
              </p>
              <a
                href="/pages/contact"
                className="mt-3 inline-flex items-center gap-2 rounded-xl bg-pink text-white px-5 py-3 font-semibold shadow-sm hover:opacity-90 transition-opacity"
              >
                Commencer l&apos;enquête
                <Icon.ArrowRight size={18} weight="bold" />
              </a>
            </div>

            <div className="rounded-2xl border border-pink/20 bg-white/50 p-5">
              <h4 className="font-bold">
                Visitez-nous sur les plateformes de médias sociaux
              </h4>
              <p className="text-sm pt-1 pb-2">
                Retrouvez-nous sur nos réseaux pour nos nouveautés et promotions.
              </p>
              <div className="flex items-center gap-3 mt-4">
                <a
                  href="https://www.facebook.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-11 h-11 rounded-full bg-pink text-white flex items-center justify-center shadow-sm hover:scale-105 transition-transform"
                  aria-label="Facebook"
                >
                  <Icon.FacebookLogo size={22} weight="fill" />
                </a>
                <a
                  href="https://www.instagram.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-11 h-11 rounded-full bg-pink text-white flex items-center justify-center shadow-sm hover:scale-105 transition-transform"
                  aria-label="Instagram"
                >
                  <Icon.InstagramLogo size={22} weight="fill" />
                </a>
                <a
                  href="https://www.youtube.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-11 h-11 rounded-full bg-pink text-white flex items-center justify-center shadow-sm hover:scale-105 transition-transform"
                  aria-label="YouTube"
                >
                  <Icon.YoutubeLogo size={22} weight="fill" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer" className="footer relative overflow-hidden">
        <img
          src='/designWomen.png'
          width={900}
          height={900}
          alt="bg-img"
          className="object-cover rounded-md absolute right-0 top-0 w-[560px] h-full max-sm:hidden"
        />
        <div className="footer-main bg-pink text-white">
          <div className="container">
            <div className="content-footer py-[60px] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
              {/* Company Info & Contact */}
              <div className="company-infor lg:col-span-1">
                <a href={"/"} className="logo block mb-6">
                  <img
                    src='/logo white.png'
                    width={700}
                    height={700}
                    alt="Kissaria Logo"
                    className="object-cover relative z-10"
                    style={{
                      width: "121px",
                    }}
                  />
                </a>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <Icon.Envelope className="text-white mt-1 flex-shrink-0" size={18} />
                    <div>
                      <p className="text-button-uppercase text-white/80 mb-1">Email</p>
                      <a href="mailto:contact@kissariti.ma" className="caption1 text-white hover:text-yellow transition-colors">
                        contact@kissariti.ma
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <Icon.Phone className="text-white mt-1 flex-shrink-0" size={18} />
                    <div>
                      <p className="text-button-uppercase text-white/80 mb-1">Téléphone</p>
                      <a href="tel:+212664045333" className="caption1 text-white hover:text-yellow transition-colors block">
                        +212 664 045 333
                      </a>
                      <a href="tel:+212521201115" className="caption1 text-white hover:text-yellow transition-colors block mt-1">
                        +212 521 201 115
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <Icon.MapPin className="text-white mt-1 flex-shrink-0" size={18} />
                    <div>
                      <p className="text-button-uppercase text-white/80 mb-1">Adresse</p>
                      <p className="caption1 text-white">
                        Sidi Maarouf, Casablanca
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Information Links */}
              <div className="item flex flex-col">
                <h5 className="text-button-uppercase text-white pb-4 mb-4 border-b border-white/20">Information</h5>
                <div className="flex flex-col gap-3">
                  <a
                    className="caption1 text-white/80 hover:text-yellow duration-300 w-fit transition-colors"
                    href={"/pages/contact"}
                  >
                    Contactez-nous
                  </a>
                  <a
                    className="caption1 text-white/80 hover:text-yellow duration-300 w-fit transition-colors"
                    href={"/pages/livraison-et-retour"}
                  >
                    Livraison & Retour
                  </a>
                  <a
                    className="caption1 text-white/80 hover:text-yellow duration-300 w-fit transition-colors"
                    href={"/pages/politique-de-confidentialite"}
                  >
                    Politique de confidentialité
                  </a>
                </div>
              </div>

              {/* Quick Shop Links */}
              <div className="item flex flex-col">
                <h5 className="text-button-uppercase text-white pb-4 mb-4 border-b border-white/20">Achat Rapide</h5>
                <div className="flex flex-col gap-3">
                  <a
                    className="caption1 text-white/80 hover:text-yellow duration-300 w-fit transition-colors"
                    href={"/shop/"}
                  >
                    Femmes
                  </a>
                  <a
                    className="caption1 text-white/80 hover:text-yellow duration-300 w-fit transition-colors"
                    href={"/shop/"}
                  >
                    Hommes
                  </a>
                  <a
                    className="caption1 text-white/80 hover:text-yellow duration-300 w-fit transition-colors"
                    href={"/shop/"}
                  >
                    Vêtements
                  </a>
                  <a
                    className="caption1 text-white/80 hover:text-yellow duration-300 w-fit transition-colors"
                    href={"/shop/"}
                  >
                    Accessoires
                  </a>
                </div>
              </div>

              {/* Social Media */}
              <div className="item flex flex-col">
                <h5 className="text-button-uppercase text-white pb-4 mb-4 border-b border-white/20">Suivez-nous</h5>
                <p className="caption1 text-white/80 mb-4">
                  Restez connecté avec nous sur les réseaux sociaux
                </p>
                <div className="list-social flex items-center gap-4">
                  <a 
                    href={"https://www.facebook.com/"} 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-all duration-300 hover:scale-110"
                    aria-label="Facebook"
                  >
                    <Icon.FacebookLogo className="text-white" size={20} />
                  </a>
                  <a 
                    href={"https://www.instagram.com/"} 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-all duration-300 hover:scale-110"
                    aria-label="Instagram"
                  >
                    <Icon.InstagramLogo className="text-white" size={20} />
                  </a>
                  <a 
                    href={"https://www.twitter.com/"} 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-all duration-300 hover:scale-110"
                    aria-label="Twitter"
                  >
                    <i className="icon-twitter text-white text-xl"></i>
                  </a>
                  <a 
                    href={"https://www.youtube.com/"} 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-all duration-300 hover:scale-110"
                    aria-label="YouTube"
                  >
                    <Icon.YoutubeLogo className="text-white" size={20} />
                  </a>
                </div>
              </div>
            </div>
            <div className="footer-bottom py-4 flex items-center justify-between gap-5 max-lg:justify-center max-lg:flex-col border-t border-line">
              <div>
                <img
                  src="/payment.png"
                  width={900}
                  height={900}
                  alt="bg-img"
                  className="object-cover rounded-md w-40"
                />
              </div>
              <p className="text-surface max-sm:text-center z-50">
                Kissariti © 2026 Online Store. All Rights Reserved
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
